import { css as i } from "@microsoft/fast-element";
import { normalize as n } from "../common/normalize.js";
import { display as r } from "@matrix42/fast-foundation";
import { designTokens as o } from "../design-tokens.js";
const s = i`
  ${n}
  ${r("flex")}
  .positioning-region {
    /* Layout */
    display: flex;
  }

  .positioning-region.horizontal {
    /* Layout */
    gap: ${o.spacing[8]};
  }

  .positioning-region.vertical {
    /* Layout */
    flex-direction: column;
    gap: ${o.spacing[4]};
  }
`;
export {
  s as radioGroupStyles
};
